class Errors {
    constructor() {
        this.errors = []
    }
    set(name, message) {
        const errorMesage = message ? message : ''
        if (this.has(name)) {
            return
        }
        this.errors.push({ name: name, message: errorMesage })
    }
    has(name, section) {
        return (
            this.errors.findIndex(
                error =>
                    error.name == name &&
                    (error.section == section || !error.section)
            ) > -1
        )
    }
    clear(name) {
        const index = this.errors.findIndex(error => error.name == name)
        index != -1 ? this.errors.splice(index, 1) : ''
    }
    getMessage(name) {
        const index = this.errors.findIndex(error => error.name == name)
        return index != -1 ? this.errors[index].message : ''
    }
}

export default Errors
